// extracted by mini-css-extract-plugin
module.exports = {"circle":"Handle_circle__1BinW","active":"Handle_active__4VMw-","activeBg":"Handle_activeBg__2vNb5"};